import { ColorInterface, Color } from '@3ddv/ngx-sites-builder-lib';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SbApiService } from 'src/app/sites-builder/services/sb-api.service';
import { SblibService } from '../../services/sblib.service';
import { ToolsService } from '../services/tools.service';
import { ColorInterfaceTemplate } from './templates/models/colorinterfacetemplate.model';
import { TemplatesComponent } from './templates/templates.component';

@Component({
  selector: 'app-sbeditor-tool-colorinterface',
  templateUrl: './colorinterface.component.html',
  styleUrls: ['./colorinterface.component.scss'],
})
export class ColorinterfaceComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  private tool: Color;
  public custom_colors: ColorInterface;
  public currenttab = { custom: true, templates: false };
  @ViewChild('templates') templatesChildrenComp: TemplatesComponent;

  public total_templates: number = 0;

  constructor(
    private toolsService: ToolsService,
    private sblibService: SblibService,
    private apiService: SbApiService,
    private changeDetector: ChangeDetectorRef,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute
  ) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      if (res.color) {
        this.tool = res.color;
      } else {
        console.error('color tool not found');
        return;
      }
      this.custom_colors = JSON.parse(JSON.stringify(res.color.manual));
    });
    this.subscriptions.push(tools$);

    this.total_templates = this.activatedRoute.snapshot.data.dataFlow.workflow.template_colors.length;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public switchTab(tab) {
    this.currenttab = { custom: false, templates: false };
    this.currenttab[tab] = true;
  }

  // Copy applied template to custom
  public onApplyTemplate(templatedb: ColorInterfaceTemplate) {
    this.custom_colors = JSON.parse(JSON.stringify(templatedb.values));
  }

  public onCreateTemplate(templatedb: ColorInterfaceTemplate) {
    const body = {
      name: templatedb.name,
      workflow_id: this.activatedRoute.snapshot.data.dataFlow.workflow.id,
      values: JSON.stringify(templatedb.values),
    };

    const u$ = this.apiService.createTemplate(body).subscribe(res => {
      if (res) {
        const newtemplate = res.template_color;
        if (typeof newtemplate.values === 'string') {
          newtemplate.values = JSON.parse(newtemplate.values);
        }
        this.switchTab('templates');
        this.changeDetector.detectChanges();
        // Los templates vienen ordenados por fecha de modificación: le damos la vuelta para pushear
        let reversed = this.templatesChildrenComp.templates.reverse();
        reversed.push(newtemplate);
        // Le volvemos a dar la vuelta para que salga en el orden de creación correcto.
        this.templatesChildrenComp.templates = reversed.reverse();
        this.total_templates = this.templatesChildrenComp.templates.length;
        this.toastrService.success('', 'Success');
      }
    });
    this.subscriptions.push(u$);
  }

  public onTemplatesListUpdate(templates: Array<ColorInterfaceTemplate>) {
    this.total_templates = templates.length;
  }
}
